import React from 'react';

/**
 * Base for hand-authored SVG icon components (WasteHero / Central Icons exported
 * as raw SVG and committed locally — no npm dependency, no license key).
 *
 * All colors in the source SVGs are normalized to `currentColor`, so an icon
 * takes the surrounding text color and can be recolored via `color`/CSS. The
 * prop surface matches the previous icon set: `size` (default 24) drives both
 * width and height, and every other SVG attribute (`className`, `style`,
 * `color`, `onClick`, `aria-*`, …) is spread onto the `<svg>`.
 */
export type SvgIconProps = React.SVGProps<SVGSVGElement> & {
  size?: number | string;
};

export const createSvgIcon = (
  paths: React.ReactNode,
  displayName: string,
  viewBox = '0 0 24 24'
) => {
  const Icon: React.FC<SvgIconProps> = ({ size = 24, ...props }) => (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      {paths}
    </svg>
  );
  Icon.displayName = displayName;
  return Icon;
};
